import SegmentPage from "@/pages/segments/SegmentPage";

export default function ProfessionalPage() {
  return (
    <SegmentPage
      testId="professional-page"
      leadSegment="professional"
      whitepaperLabel="Enterprise Athlete Intelligence Playbook"
      eyebrow="For Professional Organizations"
      headline={<>Standardize intelligence across every affiliate.</>}
      subhead={
        <>
          Enterprise infrastructure for organizations managing athletes across multiple teams and developmental levels — from complex leagues to college feeder pipelines.
        </>
      }
      tone="#D90429"
      ctaLabel="Talk to enterprise"
      secondaryLabel="Read the platform"
      secondaryHref="/why"
      focus={[
        "Organizational consistency",
        "Affiliate benchmarking",
        "Enterprise analytics",
        "Secure infrastructure",
        "API architecture",
        "White-label",
      ]}
      outcomes={[
        { title: "Organizational consistency.", body: "Every affiliate — every academy — every developmental level running the same evaluation battery, the same intelligence layer, the same standards." },
        { title: "Standardized evaluations.", body: "One movement battery, one workload taxonomy, one readiness scale. Compare athletes across affiliates with confidence." },
        { title: "Reduced information silos.", body: "Executive rollup dashboards show org-wide holds, cautions, and risk trends — no more Monday-morning surprises." },
        { title: "Enterprise decision support.", body: "White-label branded surfaces, SSO, custom domains, API access, and secure data infrastructure fit for a professional organization." },
      ]}
    />
  );
}
